import { render, staticRenderFns } from "./dutyList.vue?vue&type=template&id=549f2a42"
import script from "./dutyList.vue?vue&type=script&lang=js"
export * from "./dutyList.vue?vue&type=script&lang=js"
import style0 from "./dutyList.vue?vue&type=style&index=0&id=549f2a42&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports